<script setup>
import { ref, computed } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';

const storeField = useFieldsStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value)

const errorText = ref(null)

const heightErrorText = computed(() => {
    if (errorText.value) {
        return errorText.value.offsetHeight;
    }
})

defineProps({
    type: {
        type: String,
        default: 'text',
    },
    stateKey: {
        type: String,
    },
    placeholder: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
    },
    readonly: {
        type: Boolean,
        default: false  
    },
    responseError: {
        type: Object, 
        default: () => ({ active: false, text: '' })
    }
})
</script>
<template>
    <label :class="['input']">        
        <div class="input__holder" :class="[isTouched && (isValid ? 'valid' : 'not-valid')]">
            <input 
            :type="type"
            :placeholder="placeholder"
            :required="required"
            :class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid') ]"
            @input="storeField.updateFields(stateKey, 'title', value), validation(stateKey)"  
            @blur="() => readonly ? null : validation(stateKey)"
            v-model="value"
            :readonly="readonly"                      
            >
            <span class="input__title"><slot></slot></span>
        </div>
        <Transition mode="out-in">
            <span v-if="!!textError" ref="errorText" class="input__error" :style="{ bottom: `${(heightErrorText + 10) * -1}px` }">{{ textError }}</span>
        </Transition>
        
    </label>
</template>
<style lang='scss' scoped>



.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}

</style>